import { useIntl } from 'react-intl';

import { Header } from '~/eds/src/components/Header/Header';
import { Nullable } from '~/types/Nullable';

import { PromptModelPublishStatus } from '../../../../redux/api/types/sylvanus/model';
import { ModelVersion } from '../../types/model';
import { getModelHeader } from '../utils';

interface Props {
  modelVersion: ModelVersion;
  modelName: string;
  publishStatus: Nullable<PromptModelPublishStatus>;
}
export const ModelTitle = ({
  publishStatus,
  modelVersion,
  modelName,
}: Props) => {
  const intl = useIntl();
  const header = getModelHeader({
    model: {
      ...modelVersion,
      publishStatus,
    },
    name: modelName,
    intl,
  });

  return <Header {...header} enablePadding={false} />;
};
